// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__UHKpy","searchIcon":"Search_searchIcon__0x7Z+","input":"Search_input__IfsyX"};